import React, { useState } from 'react';
import Dropzone, { ErrorCode } from 'react-dropzone';
import PropTypes from 'prop-types';

import { reduxFormPropTypes } from 'constants/propTypes';
import Message from 'components/Message';
import { SvgImageUpload, SvgEdit } from 'components/Svgs/';
import { INSTRUCTOR_PHOTO_MAX_BYTES } from 'helpers/proxy-api-errors';
import { messages } from './InstructorFormOptionalLabel';
import { messages as instructorMessages } from '../../Instructors.messages';

const hasUploadedFiles = value => Array.isArray(value) && value.length > 0;

const InstructorFormAvatar = ({ name, input, pictureUrl }) => {
  const [photoTooLarge, setPhotoTooLarge] = useState(false);
  const files = input.value;
  const picture = hasUploadedFiles(files) ? URL.createObjectURL(files[0]) : pictureUrl;
  const pictureAlt = hasUploadedFiles(files) ? files[0].name : 'Avatar';
  const handleOnDropAccepted = filesToUpload => {
    setPhotoTooLarge(false);
    input.onChange(filesToUpload);
  };
  const handleOnDropRejected = rejections => {
    const isTooLarge = rejections.some(({ errors }) => errors.some(error => error.code === ErrorCode.FileTooLarge));
    if (isTooLarge) {
      setPhotoTooLarge(true);
    }
  };

  return (
    <div className="instructor-form__avatar">
      <Dropzone
        accept={{ 'image/jpeg': [], 'image/png': [], 'image/gif': [] }}
        maxSize={INSTRUCTOR_PHOTO_MAX_BYTES}
        name={name}
        onDropAccepted={handleOnDropAccepted}
        onDropRejected={handleOnDropRejected}>
        {({ getRootProps, getInputProps }) => (
          <div className="instructor-form__dropzone" {...getRootProps()}>
            <input {...getInputProps()} />
            {picture ? (
              <div className="instructor-form__filled-picture">
                <img className="instructor-form__picture" src={picture} alt={pictureAlt} />
                <SvgEdit className="instructor-form__add-icon" stroke="red" />
              </div>
            ) : (
              <div className="instructor-form__empty-picture">
                <SvgImageUpload />
                <Message
                  as="p"
                  className="instructor-form__empty-picture-optional-text"
                  message={messages.optionalLabel}
                />
              </div>
            )}
          </div>
        )}
      </Dropzone>
      {photoTooLarge && (
        <Message as="p" className="instructor-form__error" message={instructorMessages.error.photoTooLarge} />
      )}
    </div>
  );
};

InstructorFormAvatar.propTypes = {
  pictureUrl: PropTypes.string,
  name: PropTypes.string,
  input: reduxFormPropTypes.field.input,
};

export default InstructorFormAvatar;
